import React from 'react'
import axios from 'axios'
import { hydrateRoot } from 'react-dom/client'
import App from './App'

function getQueryParams() {
  const searchParams = new URLSearchParams(window.location.search);
  const params = {};
  
  for (const [key, value] of searchParams.entries()) {
    params[key] = value;
  }
  
  return params;
}

const get = getQueryParams();

async function getInitialData() {
  // Если данные уже были переданы с сервера — используем их
  if (window.__INITIAL_DATA__) {
    // Если это строка — парсим (на случай если JSON был экранирован)
    if (typeof window.__INITIAL_DATA__ === 'string') {
      try {
        return JSON.parse(window.__INITIAL_DATA__);
      } catch (e) {
        console.error('Ошибка парсинга __INITIAL_DATA__:', e);
      }
    }
    return window.__INITIAL_DATA__;
  }

  // Иначе делаем axios-запрос
  const response_page = await axios.post(`https://${window.location.host}${window.location.pathname}`, {
    content_type: 'application/json',
    action: 'load_page_data',
    get: get
  }, {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Request-Source': 'Node.js'
    }
  })
  return response_page?.data || {}
}

const data = await getInitialData()

hydrateRoot(
  document.getElementById('pizzaokidoki'),
  <App
    data={data}
    get={get}
  />
)